import React from 'react';

const HierarchyContext = React.createContext({
  register: (_key: string, _area: any) => {},
  unregister: (_key: string) => {},
  state: {},
});

export default HierarchyContext;
